import styled from 'styled-components';

export const ActionsContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
`;

export const ActionButton = styled.a<{danger?: boolean}>`
  align-items: center;
  background-color: #ffffff;
  cursor: pointer;
  color: ${({danger}) => (danger ? '#f44336' : '#006bf3')};
  display: flex;
  font-size: 0.66em;
  gap: 1rem;
  height: 30px;
  justify-content: center;
  padding: 0 20px;
  &:hover {
    background-color: ${({danger}) => (danger ? '#f44336' : '#006bf3')};
    color: #ffffff;
  }
  i {
    font-size: 1em;
  }
`;

const invertColor = (color: string) => {
  const hex = color.replace('#', '');
  if (hex.length !== 6) return '#000000';

  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;

  const normalize = (component: number) =>
    component <= 0.03928
      ? component / 12.92
      : ((component + 0.055) / 1.055) ** 2.4;

  const luminance =
    0.2126 * normalize(r) + 0.7152 * normalize(g) + 0.0722 * normalize(b);

  return luminance > 0.5 ? '#000000' : '#ffffff';
};

export const PlanLabel = styled.small<{color: string}>`
  background-color: ${({color}) => color};
  color: ${({color}) => (color ? invertColor(color) : '#ffffff')};
  border-radius: 5px;
  padding: 10px;
`;
